module.exports = __webpack_public_path__ + "img/2D.1c8adbb3.svg";